<cap-list-loader [listLoader]="listLoader" [showTotal]="showTotal" [showZeilenSelect]="showZeilenSelect">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'EPROID'" [sortModel]="tableSortModel.columns.get(EPROID)"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'AmtlicheBaudossiernummer'" [sortModel]="tableSortModel.columns.get(AMTLICHE_BAUDOSSIERNUMMER)">
      </cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Grundstücke'" [sortModel]="tableSortModel.columns.get(GRUNDSTUECKE)"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Projektstatus'" [sortModel]="tableSortModel.columns.get(PROJEKTSTATUS)"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Projektumschreibung'" [sortModel]="tableSortModel.columns.get(PROJEKTUMSCHREIBUNG)">
      </cap-column-header>
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      <td>
        <cap-link [params]="[item.eproid.value]" [target]="navTargets.NAV_GWR_BAUPROJEKT" [tooltipParams]="{ nummer: item.eproid.value }">
          {{ item.eproid.value }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[item.eproid.value]" [target]="navTargets.NAV_GWR_BAUPROJEKT" [tooltipParams]="{ nummer: item.eproid.value }">
          {{ item.amtlicheBaudossiernummer }}
        </cap-link>
      </td>
      <td>
        @for (grundstueck of item.grundstuecke; track grundstueck; let i = $index) {
          @if (i < maxGrundstueckeProBauprojekt) {
            <p>
              <cap-link
                [queryParams]="getGrundstueckQueryParams(grundstueck.grundstueckNummer)"
                [target]="navTargets.NAV_GRUNDSTUECK"
                [tooltipOverride]="'DetailsZuGrundstueckAusSichtGrundbuch'">
                {{ grundstueck | kompaktGwrGrundstueck }}
              </cap-link>
            </p>
          }
          @if (i === maxGrundstueckeProBauprojekt) {
            ...<br />
          }
        }
      </td>
      <td>
        <cap-link [params]="[item.eproid.value]" [target]="navTargets.NAV_GWR_BAUPROJEKT" [tooltipParams]="{ nummer: item.eproid.value }">
          {{ item.projektstatus | translate }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[item.eproid.value]" [target]="navTargets.NAV_GWR_BAUPROJEKT" [tooltipParams]="{ nummer: item.eproid.value }">
          {{ item.projektumschreibung }}
        </cap-link>
      </td>
    </tr>
  }
</ng-template>
